import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class AssemblyGroupService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves the available assembly groups.
     *
     * @datatask 3238
     * @datataskName tt_assemblygroup_list
     * @returns promise containing the assembly groups for the current language.
     */
    public getAssemblyGroups(): Promise<AssemblyGroupItem[]> {
        return this.datatask.Post(3238);
    }
}

export interface AssemblyGroupItem {
    assemblygroup_id: string;
    assemblygroup_name: string;
    orderby: string | number;
}
